/**
 * TLF Animations — The Little Furnette
 * Intersection Observer for scroll-triggered animations
 * Floating particles, geometric decorations
 * Respects prefers-reduced-motion
 */
(function () {
  'use strict';

  // Respect reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    // Make all animated elements visible immediately
    document.querySelectorAll('.tlf-animate, .tlf-animate-scale, .tlf-animate-left, .tlf-animate-right').forEach(function (el) {
      el.classList.add('tlf-visible');
    });
    return;
  }

  // Intersection Observer for scroll-triggered animations
  var observerOptions = {
    root: null,
    rootMargin: '0px 0px -60px 0px',
    threshold: 0.15
  };

  var animationObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('tlf-visible');
        animationObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe all animated elements
  function initAnimations() {
    var animatedElements = document.querySelectorAll(
      '.tlf-animate, .tlf-animate-scale, .tlf-animate-left, .tlf-animate-right'
    );

    animatedElements.forEach(function (el) {
      animationObserver.observe(el);
    });
  }

  // Auto-stagger children inside .tlf-stagger containers
  function initStagger() {
    var staggerContainers = document.querySelectorAll('.tlf-stagger');

    staggerContainers.forEach(function (container) {
      var children = container.querySelectorAll('.tlf-animate, .tlf-animate-scale');
      children.forEach(function (child, index) {
        var delay = (index + 1) * 0.1;
        child.style.transitionDelay = delay + 's';
      });
    });
  }

  // --- Scroll-triggered SVG category animations ---
  function initCategorySVGAnimations() {
    var catItems = document.querySelectorAll('.tlf-cat-svg');
    if (!catItems.length) return;

    var svgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tlf-svg-active');
          svgObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    catItems.forEach(function (item) {
      svgObserver.observe(item);
    });
  }

  // --- Floating Geometric Shapes Generator ---
  function initFloatingShapes() {
    var sections = document.querySelectorAll('.tlf-categories, .section-tlf-consultation');
    var colors = ['#4D9B8A', '#E8679A', '#C9A84C', '#7B6BB5', '#6BC4A0'];
    var shapes = ['circle', 'triangle', 'square', 'diamond'];

    sections.forEach(function (section) {
      // Only add shapes if section doesn't already have them
      if (section.querySelector('.tlf-floating-shape')) return;

      for (var i = 0; i < 5; i++) {
        var shape = document.createElement('div');
        shape.className = 'tlf-floating-shape';
        shape.style.cssText = [
          'position: absolute',
          'pointer-events: none',
          'z-index: 0',
          'opacity: 0.06',
          'width: ' + (20 + Math.random() * 30) + 'px',
          'height: ' + (20 + Math.random() * 30) + 'px',
          'left: ' + (Math.random() * 90 + 5) + '%',
          'top: ' + (Math.random() * 80 + 10) + '%',
          'border: 1.5px solid ' + colors[i % colors.length],
          'animation: tlfDrift ' + (18 + Math.random() * 12) + 's ease-in-out infinite',
          'animation-delay: -' + (Math.random() * 10) + 's'
        ].join(';');

        var shapeType = shapes[i % shapes.length];
        if (shapeType === 'circle') {
          shape.style.borderRadius = '50%';
        } else if (shapeType === 'triangle') {
          shape.style.width = '0';
          shape.style.height = '0';
          shape.style.border = 'none';
          shape.style.borderLeft = '12px solid transparent';
          shape.style.borderRight = '12px solid transparent';
          shape.style.borderBottom = '20px solid ' + colors[i % colors.length];
          shape.style.opacity = '0.05';
        } else if (shapeType === 'diamond') {
          shape.style.transform = 'rotate(45deg)';
          shape.style.borderRadius = '3px';
        } else {
          shape.style.borderRadius = '3px';
        }

        section.appendChild(shape);
      }
    });
  }

  // --- Parallax subtle scroll on decorative elements ---
  function initParallaxDeco() {
    var blobs = document.querySelectorAll('.tlf-deco-blob');
    var canvasOrbs = document.querySelectorAll('.tlf-canvas__orb');
    var canvasRainbow = document.querySelector('.tlf-canvas__rainbow');

    if (!blobs.length && !canvasOrbs.length) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollY = window.pageYOffset;
          var docHeight = document.documentElement.scrollHeight - window.innerHeight;
          var scrollPercent = docHeight > 0 ? scrollY / docHeight : 0;

          // Section blobs — gentle parallax
          blobs.forEach(function (blob, i) {
            var speed = (i % 2 === 0) ? 0.02 : -0.015;
            blob.style.transform = 'translateY(' + (scrollY * speed) + 'px)';
          });

          // Canvas orbs — very slow parallax, each at different speed
          canvasOrbs.forEach(function (orb, i) {
            var speeds = [0.03, -0.02, 0.025, -0.015];
            orb.style.transform = 'translateY(' + (scrollY * speeds[i % speeds.length]) + 'px)';
          });

          // Rainbow arc — subtle fade as user scrolls past it
          if (canvasRainbow) {
            var rainbowOpacity = Math.max(0, 1 - (scrollPercent * 2.5));
            canvasRainbow.style.opacity = rainbowOpacity;
          }

          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // Initialize on DOM ready
  function initAll() {
    initStagger();
    initAnimations();
    initCategorySVGAnimations();
    initFloatingShapes();
    initParallaxDeco();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialize on Shopify section re-render
  document.addEventListener('shopify:section:load', initAll);
})();
